<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-11 17:02:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div
    class="Index-wrap"
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="Index-content">
      <div class="Index-top">
        <div class="Index-top-userInfo">
          <div style="display: flex">
            <div class="Index-top-img"><img src="../../assets/image/userAvatar.png" alt="" /></div>
            <div class="Index-top-info" v-if="userName">
              <div>
                {{
                  userName
                    ? userName
                        .split('')
                        .map((item, index) => (index % 2 == 0 ? '*' : item))
                        .join('')
                    : ''
                }}
              </div>
              <div>{{ cardCode ? cardCode : '' }}</div>
            </div>
            <div v-else style="line-height: 0.5rem; margin-left: 0.1rem">暂未绑定</div>
          </div>
          <div class="Index-top-changeNumber" @click="handleChangeNumber">切换卡号</div>
        </div>
        <div class="Index-top-function">
          <div @click="removeBinding">{{ cardCode ? '解绑' : '房屋绑定' }}</div>
          <div @click="getPayRecord">缴费记录</div>
          <div @click="skip('appointmentInfo')">我的预约</div>
        </div>
      </div>

      <div class="Index-menu">
        <div class="Index-pay" @click="getBindingInfo('searchResult')">
          <div class="Index-menu-img"></div>
          <div class="Index-menu-text">在线缴费</div>
        </div>
        <div class="Index-insurance" >
          <div class="Index-menu-img"></div>
          <div class="Index-menu-text">代办漏水险</div>
        </div>
        <!-- <div class="Index-warranty" @click="skip('warranty')">
          <div class="Index-menu-img">
            </div>
          <div class="Index-menu-text">在线报修</div>
        </div> -->
        <div class="Index-warranty" @click="getBindingInfo('ownerMessage')">
          <div class="Index-menu-img"></div>
          <div class="Index-menu-text">在线续停</div>
        </div>
        <!-- <div class="Index-appointment" @click="skip('appointment')">
          <div class="Index-menu-img"></div>
          <div class="Index-menu-text">大厅预约</div>
        </div> -->
        <div class="Index-appointment" @click="getBindingInfo('heatMetering')">
          <div class="Index-menu-img"></div>
          <div class="Index-menu-text">热计量公示</div>
        </div>
      </div>

      <div class="mark-index" v-if="markFlag">
        <div v-if="bindingFlag" style="height: 2rem">
          <div style="text-align: right; padding: 0.1rem 0.15rem; color: #aaaaaa">
            <i
              class="iconfont iconguanbi"
              @click="
                markFlag = false;
                bindingFlag = false;
              "
            ></i>
          </div>
          <div style="margin-top: 0.4rem">
            <div style="color: #007b83">请您再次确认房屋{{ cardCode }}解绑</div>
            <div class="mark-binding">
              <el-button
                type="primary"
                style="
                  width: 0.6rem;
                  height: 0.3rem;
                  padding: 0 0;
                  background: #007b83;
                  border: none;
                  color: #fff;
                "
                @click="affirmBinding"
                >确认</el-button
              >
              <el-button
                style="
                  width: 0.6rem;
                  height: 0.3rem;
                  padding: 0 0;
                  border: 1px solid #007b83;
                  color: #007b83;
                "
                @click="
                  markFlag = false;
                  bindingFlag = false;
                "
                >取消</el-button
              >
            </div>
          </div>
        </div>
        <div v-else>
          <div style="text-align: right; padding: 0.1rem 0.15rem; color: #aaaaaa">
            <i class="iconfont iconguanbi" @click="markFlag = false"></i>
          </div>
          <div style="color: #007b83; margin-top: 0.14rem">
            <div v-if="appointmentFlag">
              <div>抱歉，当前预约功能关闭中~</div>
            </div>
            <div v-if="warrantyFlag">
              <div>抱歉，报修功能暂未开放~</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'index',
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      markFlag: false,
      appointmentFlag: false,
      warrantyFlag: false,
      cardCode: '', // 供热卡号
      userName: '', // 用户姓名
      loading: false,
      loadingText: '', // loading信息
      bindingFlag: false,
    };
  },

  methods: {
    // 切换卡号
    handleChangeNumber() {
      this.$router.push({
        name: 'cardCodeManage',
      });
    }, // 查询办理续停资格
    async getContinueStopInfo() {
      this.loading = true;
      this.loadingText = '正在查询您的续停资格，请稍等';
      const res = await this.$http.get(this.$url.globalurl + '/wxContinueStop/0');
      console.log(res);
      if (res.code === 200) {
        if (res.result) {
          // 跳转到填写房屋信息页面
          this.$router.push({
            name: 'ownerMessage',
            // query:{
            //   cardCode:this.cardCode,
            //   userName:this.userName,
            //   payFlag:true
            // }
          });
        } else {
          // 不符合办理续停条件
          this.$router.push({
            name: 'searchHint',
            query: {
              noContinueStop: true,
            },
          });
        }
      }
      this.loading = false;
    },
    // 查询供暖缴费资格
    async getheatingInfo() {
      this.loading = true;
      this.loadingText = '正在查询您的缴费资格，请稍等';
      const res = await this.$http.get(this.$url.globalurl + '/wxPayMent/0');
      if (res.code === 200) {
        if (res.result.can_paid) {
          // 取暖费跳转
          this.$router.push({
            name: 'searchResult',
            query: {
              cardCode: this.cardCode,
              userName: this.userName,
              payFlag: true,
            },
          });
        } else {
          // 没有交费资格
          this.$router.push({
            name: 'searchHint',
            query: {
              payFlag: true,
              payTime: res.result.time,
              message: res.result.message,
            },
          });
        }
      }
      this.loading = false;
    },
    // 查询跑漏险缴费资格
    async getInsuranceInfo() {
      this.loading = true;
      this.loadingText = '正在查询您的缴费资格，请稍等';
      const res = await this.$http.get(this.$url.globalurl + '/wxPayMent/0', {
        data: {
          risk: true,
        },
      });
      if (res.code === 200) {
        if (res.result.can_paid) {
          this.loading = false;
          // 跑漏险跳转
          this.$router.push({
            name: 'insurance',
            query: {
              cardCode: this.cardCode,
              phone: this.phone,
              payFlag: false,
              userName: this.userName,
            },
          });
        } else {
          this.loading = false;
          // 没有交费资格
          this.$router.push({
            name: 'searchHint',
            query: {
              payFlag: false,
              payTime: res.result.time,
              message: res.result.message,
            },
          });
        }
      }
    },
    async skip(routerName) {
      if (routerName === 'appointment' || routerName === 'appointmentInfo') {
        this.loading = true;
        this.loadingText = '稍等，正在查询预约开放状态';
        const res = await this.$http.get(
          `${this.$url.globalurl}/systemConfig/${sessionStorage.getItem('customer_id')}`
        );
        if (!res.result[0].reservation_status) {
          this.loading = false;
          this.warrantyFlag = false;
          this.markFlag = true;
          return (this.appointmentFlag = true);
        }
      }
      if (routerName === 'warranty') {
        this.appointmentFlag = false;
        this.markFlag = true;
        return (this.warrantyFlag = true);
      }
      this.$router.push({
        name: routerName,
      });
    },
    // 查询是否绑定了房屋信息
    async getBindingStatus() {
      this.loading = true;
      this.loadingText = '正在查询您的绑定信息，请稍等';
      const res = await this.$http.get(`${this.$url.globalurl}/wxUser/0`);
      console.log(res);
      if (res.result && res.result.length) {
        this.cardCode = res.result[0].heating_card_num;
        const hourRes = await this.$http.get(`${this.$url.globalurl}/wxHouseInfo`);
        this.userName = hourRes.result.owner_name;
      }
      this.loading = false;
    },
    // 查询用户的绑定信息
    async getBindingInfo(routerName) {
      this.loading = true;
      this.loadingText = '正在查询您的绑定信息，请稍等';
      const res = await this.$http.get(`${this.$url.globalurl}/wxUser/0`);
      if (res.result.length) {
        if (routerName == 'searchResult') {
          this.getheatingInfo();
        } else if (routerName == 'insurance') {
          this.getInsuranceInfo();
        } else if (routerName == 'ownerMessage') {
          this.getContinueStopInfo();
        } else if (routerName == 'heatMetering') {
          this.$router.push({
            name: 'heatMetering',
          });
        }
      } else {
        this.$router.push({
          name: 'bindingInfo',
          query: {
            routerName,
          },
        });
      }
      this.loading = false;
    },
    // 缴费记录
    getPayRecord() {
      this.$router.push({
        name: 'payRecord',
      });
    },
    // 取消绑定
    removeBinding() {
      if (!this.cardCode) {
        this.$router.push({
          name: 'bindingInfo',
        });
      }
      this.markFlag = true;
      this.bindingFlag = true;
    },
    async affirmBinding() {
      const res = await this.$http.delete(`${this.$url.globalurl}/wxUser/0`);
      if (res.code == 200) {
        this.cardCode = '';
        this.userName = '';
        this.getBindingStatus();
      }
      // this.cardCode = '';
      // this.userName = '';
      this.markFlag = false;
      this.bindingFlag = false;
    },
  },

  mounted() {
    document.title = '首页';
    if (this.$route.query) {
      this.cardCode = this.$route.query.cardCode;
    }
    this.getBindingStatus();
  },
};
</script>
<style lang='scss' scoped>
@import url(Index.scss);
</style>
